import { LANGUAGES } from '@modeso/aumico-lib-core-fe';

export const environment = {
    firebase: {
        apiKey: 'AIzaSyD83AiJKZmK2WlStGhOcffeguBDqCSg5-M',
        authDomain: 'aumico-development.firebaseapp.com',
    },
    production: true,
    debuggingFeaturesEnabled: true,
    // REV-22118 — the ONLY production build that honours the e2e poll override (`window.__aumicoAbcpPollIntervals`,
    // app.module.ts): the abcp suite runs here, and the floor still refuses sub-second values.
    abcpPollIntervalOverride: true,
    designMode: false,
    useFirebaseAuthenticationEmulator: false,
    firebaseAuthenticationEmulatorUrl: '',
    instance: 'testing',
    modeso: {
        apiGateway: 'https://api-testing.aumico.net/api/',
        wsGateway: 'https://api-testing.aumico.net',
    },
    defaultLanguage: LANGUAGES.SWISS_GERMAN,
    enableDebugging: 'modeso:*, aumico:*',
    enableLocalizationDebugging: false,
    mixpanelEnabled: true,
    mixpanelToken: '0dc076684256df7233ceaaf15949aa6e',
    googleTagManagerEnabled: true,
    googleTagManagerId: 'GTM-5CGGD97S',
    supportUrl: 'https://aumico.freshdesk.com',
    feedbackPortalUrl: 'https://feedback-testing.aumico.net',
    host: 'https://reports-testing.aumico.net',
    // create a new task and set the taskId to the mockedTaskId to test the document upload
    mockedTaskId: 'mockedTaskId',
    /** See `environment.ts` for full semantics. `null` = gate disabled. */
    newReclassesTimestamp: '2026-06-02T00:00:00Z' as string | null,
};
